import { Table } from './table';
import './index.css';
export default Table;
